import { Autocomplete } from '@bbl-digital/snorre'
import MostFrequentRecipientsModal from 'Modules/Communication/shared/components/MostFrequentRecipientsModal'
import { RecipientTypeEnum } from 'Modules/Communication/shared/models/Inbox'
import { MessageTypeEnum } from 'Modules/Communication/shared/models/Recipients'
import { ReactNode } from 'react'
import { useAppSelector } from 'shared/store/store'
import { getSendEmailRecipients } from 'shared/store/sendMessage/email/selectors'
import { getSendSmsRecipients } from 'shared/store/sendMessage/sms/selectors'
import useRecipientHandle from '../hooks/useRecipientHandle'
import OptionList from './OptionList'
import RecipientCounter from './RecipientCounter'
import { Wrapper } from './styles'

interface IProps {
  recipientType: RecipientTypeEnum
  placeholder?: string
  label?: string
  actions?: ReactNode
  messageType: MessageTypeEnum
}

const RecipientInput: React.FC<IProps> = ({
  recipientType,
  actions,
  label,
  placeholder,
  messageType,
}) => {
  const {
    ref,
    error,
    term,
    resetTerm,
    handleOpenRecipientModal,
    handleSelect,
    handleChange,
    handleBlur,
    handleOnKeyDown,
    handleRemoveRecipient,
  } = useRecipientHandle(recipientType, messageType)
  const emailRecipients = useAppSelector(getSendEmailRecipients)
  const smsRecipients = useAppSelector(getSendSmsRecipients)

  return (
    <Wrapper>
      <Autocomplete
        label={label}
        placeholder={placeholder}
        value={term}
        inputValuesMaxWidth={300}
        // When a person just presses enter without choosing any frequent recipients
        onLabelClick={handleOpenRecipientModal}
        onSelectItem={handleSelect}
        onChange={handleChange}
        onBlur={handleBlur}
        onKeyDown={handleOnKeyDown}
        openCustomValueInputOnKeyPress
        validation
        invalidMessage={error}
        renderOptions={
          <OptionList
            messageType={messageType}
            recipientType={recipientType}
            recipients={
              messageType === MessageTypeEnum.SMS
                ? smsRecipients
                : emailRecipients
            }
            onTagClick={(e) => handleRemoveRecipient(e)()}
          />
        }
        labelSecondary={
          <RecipientCounter
            messageType={messageType}
            recipientType={recipientType}
          />
        }
        actions={actions}
        renderCustomValueInput={
          <MostFrequentRecipientsModal
            ref={ref}
            recipientType={recipientType}
            type={messageType}
            search={term}
            resetSearch={resetTerm}
          />
        }
      />
    </Wrapper>
  )
}

export default RecipientInput
